import styled from '@emotion/styled';
import { FC } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L, { LatLngExpression } from 'leaflet';

import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import { Property } from '@data/models';

const DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
});

L.Marker.prototype.options.icon = DefaultIcon;

const StyledOpenMap = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    .leaflet-container {
        position: relative;
        width: 100%;
        height: 100%;
    }

    .leaflet-control { z-index: 0 !important}
    .leaflet-pane { z-index: 0 !important}
    .leaflet-top, .leaflet-bottom {z-index: 0 !important}
`;

function getGeoPosition(data?: Dict): [number, number] {
  const lat = data?.lat || data?.latitude || 0;
  const lng = data?.lng || data?.longitude || 0;
  return [parseFloat(lat), parseFloat(lng)];
}

const OpenStreetMap: FC<Property> = (props: Property) => {
  return (
    <>
      {props.address && (
        <StyledOpenMap>
          <MapContainer
            center={getGeoPosition(props.address) as LatLngExpression}
            zoom={13}
            scrollWheelZoom={false}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker
              position={getGeoPosition(props.address) as LatLngExpression}
            >
              <Popup>{props.name}</Popup>
            </Marker>
          </MapContainer>
        </StyledOpenMap>
      )}
    </>
  );
};

export default OpenStreetMap;
